const draws = [
  {
    id: 1,
    number: 1521,
    date: "May 7, 2025",
    winningNumbers: [3, 12, 17, 26, 34, 42],
    vikingNumber: 4,
    cat1: "No winner",
    cat2: "1 winner (€654,000)",
    cat3: "5 winners (€12,000 each)",
    cat4: "103 winners (€500 each)",
    cat5: "620 winners (€70 each)",
  },
  {
    id: 2,
    number: 1520,
    date: "April 30, 2025",
    winningNumbers: [7, 15, 23, 31, 39, 44],
    vikingNumber: 1,
    cat1: "No winner",
    cat2: "No winner",
    cat3: "3 winners (€14,000 each)",
    cat4: "88 winners (€520 each)",
    cat5: "550 winners (€65 each)",
  },
  {
    id: 3,
    number: 1519,
    date: "April 23, 2025",
    winningNumbers: [2, 11, 19, 28, 35, 47],
    vikingNumber: 2,
    cat1: "1 winner (Belgium — €11,500,000)",
    cat2: "2 winners (€320,000 each)",
    cat3: "6 winners (€10,500 each)",
    cat4: "97 winners (€450 each)",
  },
  {
    id: 4,
    number: 1518,
    date: "April 16, 2025",
    winningNumbers: [6, 10, 21, 29, 33, 48],
    vikingNumber: 5,
    cat1: "No winner",
    cat2: "1 winners (€730,000)",
    cat3: "7 winners (€9,200 each)",
    cat4: "110 winners (€480 each)",
    cat5: "690 winners (€60 each)",
  },
  {
    id: 5,
    number: 1517,
    date: "April 9, 2025",
    winningNumbers: [1, 9, 14, 25, 38, 43],
    vikingNumber: 3,
    cat1: "No winner",
    cat2: "No winner",
    cat3: "4 winners (€13,000 each)",
    cat4: "91 winners (€510 each)",
    cat5: "550 winners (€65 each)",
  },
  {
    id: 6,
    number: 1516,
    date: "April 2, 2025",
    winningNumbers: [4, 13, 20, 24, 36, 46],
    vikingNumber: 2,
    cat1: "1 winner (Finland — €7,200,000)",
    cat2: "1 winner (€620,000)",
    cat3: "5 winners (€11,500 each)",
    cat4: "99 winners (€490 each)",
  },
];

export default draws;
